export const styles = () => `
.customViewButtonEye .p-button-icon-only {
  padding: 0.3125rem;
}

.action-buttons-menu-item .p-button {
  width: 100%;
}

.no-padding-button {
  & button {
    padding: 0;
  }
}
`;
